import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

type StyleProps = {
  textColor: string;
};

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  markdownContainer: {
    color: (props) => props.textColor,
    '& *': {
      color: (props) => props.textColor,
    },
  },
  paragraph: {
    marginBottom: theme.spacing(0.75),
    lineHeight: 1.6,
    fontSize: '0.8rem',
  },
  heading: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.75),
    fontWeight: 'bold',
    color: (props) => props.textColor,
  },
  subheading: {
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.5),
    fontWeight: 'bold',
    color: (props) => props.textColor,
  },
  inlineCode: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    padding: '2px 6px',
    borderRadius: '3px',
    fontFamily: '"Courier New", monospace',
    fontSize: '0.9em',
    color: (props) => props.textColor,
  },
  codeBlock: {
    display: 'block',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    padding: theme.spacing(1),
    borderRadius: '4px',
    fontFamily: '"Courier New", monospace',
    fontSize: '0.85em',
    overflow: 'auto',
    color: (props) => props.textColor,
  },
  preBlock: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    padding: theme.spacing(1),
    borderRadius: '4px',
    fontFamily: '"Courier New", monospace',
    fontSize: '0.85em',
    overflow: 'auto',
    margin: `${theme.spacing(0.5)} 0`,
    color: (props) => props.textColor,
  },
  list: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(0.75),
  },
  orderedList: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(0.75),
  },
  listItem: {
    marginBottom: theme.spacing(0.5),
    color: (props) => props.textColor,
  },
  blockquote: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    paddingLeft: theme.spacing(2),
    marginLeft: 0,
    marginBottom: theme.spacing(0.75),
    fontStyle: 'italic',
    color: (props) => props.textColor,
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    marginBottom: theme.spacing(0.75),
    border: `1px solid rgba(255, 255, 255, 0.2)`,
    maxWidth: '90%',
    overflow: 'auto',
    display: 'block',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    fontSize: '0.85em',
  },
  tableHead: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  tableBody: {},
  tableRow: {
    borderBottom: `1px solid rgba(255, 255, 255, 0.1)`,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
    },
  },
  tableHeader: {
    padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
    fontWeight: 'bold',
    borderRight: `1px solid rgba(255, 255, 255, 0.1)`,
    textAlign: 'left',
    color: (props) => props.textColor,
    whiteSpace: 'nowrap',
  },
  tableCell: {
    padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
    borderRight: `1px solid rgba(255, 255, 255, 0.1)`,
    color: (props) => props.textColor,
    whiteSpace: 'nowrap',
  },
  link: {
    color: (props) => props.textColor,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
      opacity: 0.8,
    },
  },
}));
